
import { FC, useContext, useEffect, useRef, useState } from "react";



import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import { UploadEOBsResponse, UploadProps } from "./types";

const UploadEOBs: FC<UploadProps> = ({ onClose }): JSX.Element => {
  const [uploadFile, setUploadFile] = useState<FileList | null>(null);
  const [inputKey, setInputKey] = useState(0); // for forcing input re-render
  const modalInputRef = useRef<HTMLInputElement>(null);

  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);

  const {
    loading: isFileUploading,
    error: uploadEOBsError,
    data: uploadEOBsData,
    mutate: uploadEOBsSubmit,
  } = useFetch<UploadEOBsResponse>(APIEndpoints.EOBs_Upload);

  useEffect(() => {
    if (uploadEOBsData || uploadEOBsError) {
      hideLoader();
      if (uploadEOBsData) {
        showToast(["EOB uploaded successfully."], ToastTypes.SUCCESS);
        clearDataAndForm();
        onClose && onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadEOBsData, uploadEOBsError]);
const uploadFileData = () => {
  if (uploadFile && uploadFile[0]) {
    const file = uploadFile[0];
    const maxSizeInBytes = 25 * 1024 * 1024; // 25MB

    if (file.size > maxSizeInBytes) {
       //alert("File size should not exceed 25MB.");
       showToast([`File size cannot be greater than 25mb`], ToastTypes.ERROR);
      return;
    }

    const formData = new FormData();
   formData.append("eob_document", uploadFile[0]);
      formData.append("active", "false");
      formData.append("status", "new");
    setLoader();
    uploadEOBsSubmit(formData);
  }
};
  // const uploadFileData = () => {
  //   if (uploadFile && uploadFile.length > 0) {
  //     const formData = new FormData();
  //     formData.append("eob_document", uploadFile[0]);
  //     formData.append("active", "false");
  //     formData.append("status", "new");
  //     setLoader();
  //     uploadEOBsSubmit(formData);
  //   }
  // };

  const clearDataAndForm = () => {
    setUploadFile(null);
    setInputKey((prev) => prev + 1); // force file input to re-render
  };

  const renderFileUploadSection = (
    inputRef: React.RefObject<HTMLInputElement>
  ) => (
    <>
      <div className="input-group mb-2">
        <input
          key={inputKey}
          type="file"
          className="form-control"
          id="fileUpload"
          onChange={(e) => setUploadFile(e.target.files)}
          ref={inputRef}
        />
        {uploadFile ? (
          <button
            className="btn btn-primary"
            onClick={clearDataAndForm}
            type="button"
            disabled={isFileUploading}
          >
            Clear
          </button>
        ) : null}
      </div>
      <small className="d-block">
        Click here to upload the patient's chart. Currently we accept .txt,
        .pdf, .tiff, .doc, .ccd, .cda, .ccr, .ccda and image files.
      </small>
      <small className="d-block text-danger">
          *File size cannot be greater than 25mb
      </small>
    </>
  );

  return (
    <>
      {/* Modal */}
      <div
        className="modal show d-block"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content shadow">
            <div className="modal-header">
              <h3 className="modal-title">
                Explanation Of Benefit Form&nbsp;
              </h3>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="card mb-4">
                <div className="card-body">
                  <form>
                    <p>
                      Please select and upload an Explanation of Benefits to
                      have our team de-identify it and add it to the library of
                      EOBs in our EOB Warehouse. Note that it will not appear in
                      the searchable list until the de-identification process
                      has been completed. <br />
                      <br />
                      By choosing to upload your explanation of benefits (EOB),
                      you agree that the information provided will be available
                      to Exparel and other HCPs for visibility within the
                      Provider Portal. EOBs will be redacted of all patient and
                      Provider information, so that only Plan and benefit
                      information is visible.
                    </p>
                    <div className="card-body">
                      {renderFileUploadSection(modalInputRef)}
                    </div>
                    <div className="mt-3 text-end">
                      <button
                        className="btn btn-danger mx-1 rounded-1"
                        type="button"
                        onClick={uploadFileData}
                        disabled={isFileUploading}
                      >
                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="This will remove the UploadEOBs Next Step from the cases screen and you will no longer be able to complete the precert below."
                        >
                          Upload
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default UploadEOBs;
